module.exports = __webpack_public_path__ + "static/0060-5ca6a0306c720223aa691a2adecc2ba0.png";